import { useParams } from 'next/navigation';
import { getLocalizationInfo } from 'project.config';

export const useResolvedLocalizedObject = (localized: object | string) => {
  const { locale: nextLocale } = useParams();

  const { language } = getLocalizationInfo(nextLocale);

  return localized[language as keyof typeof localized] ?? localized ?? '';
};
